<sis-loading-screen [descriptionKey1]="'OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.PROCESSING_PAYMENT_1'"
                    [descriptionKey2]="'OPEN_UNIVERSITY_CART.WIZARD.CONFIRMATION.PROCESSING_PAYMENT_2'">
</sis-loading-screen>
